import React, { useState } from "react";
import { T } from "services/lang/LanguageService";
import "./styles/style.scss";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import Remove from "./icons/Remove";
import { DatasetAxis } from "./models/types";
import DatasetLineConfigOptions, { CurrentLineConfig } from "./DatasetLineConfigOptions";

type SelectedDatasetElementProps = {
  selectedDataset: DatasetAxis;
  removeDataset: (datasetId: string) => void;
  dragStart: (e: any, identifier: string) => void;
  selectedChartType: string;
  setCurrentLineConfig: (identifier: string, currentLineConfig: CurrentLineConfig) => void;
};

const SelectedDatasetElement = ({
  removeDataset,
  selectedDataset,
  dragStart,
  selectedChartType,
  setCurrentLineConfig,
}: SelectedDatasetElementProps) => {
  const [minMaxDialogVisibility, setMinMaxDialogVisibility] = useState<boolean>(false);
  return (
    <div>
      {minMaxDialogVisibility && (
        <Dialog
          visible={minMaxDialogVisibility}
          header={`${selectedDataset.formatedTitle} ${T("label.line-config")}`}
          onHide={() => setMinMaxDialogVisibility(false)}
          className="w-6"
          draggable
          modal={false}
        >
          <DatasetLineConfigOptions
            currentLineConfig={selectedDataset.currentLineConfig}
            identifier={selectedDataset.identifier}
            setCurrentLineConfig={setCurrentLineConfig}
          />
        </Dialog>
      )}
      <div
        key={selectedDataset.identifier}
        id={selectedDataset.identifier}
        className="text selectedDataset"
        draggable
        onDragStart={e => dragStart(e, selectedDataset.identifier)}
      >
        <Tooltip target=".text" mouseTrack mouseTrackLeft={10} />
        {selectedChartType === "LINE" && (
          <i
            className="pi pi-pencil mr-2"
            style={{ cursor: "pointer" }}
            onClick={() => setMinMaxDialogVisibility(true)}
          />
        )}

        <span className="text" data-pr-tooltip={selectedDataset.formatedTitle}>
          {selectedDataset.formatedTitle}
        </span>
        <div className="removeIcon" onClick={() => removeDataset(selectedDataset.identifier)}>
          <Remove width={10} height={10} />
        </div>
      </div>
    </div>
  );
};

export default SelectedDatasetElement;
